import {Injectable, Type} from "@angular/core";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {UrlService} from "../common/url.service";
import {UsanaObject} from "../usana-object";
import { HttpClient } from "@angular/common/http";
import {LoggerService} from "../common/logger.service";
import {IMarketingPage} from "./marketing-page.models";
import {MarketingPageFactoryService} from "./marketing-page-factory.service";
import {Constants} from "../constants";

@Injectable({
    providedIn: "root"
})
export class MarketingPageService extends UsanaObject {

    constructor(private http: HttpClient,
                public loggerService: LoggerService,
                private urlService: UrlService,
                private marketingPageFactoryService: MarketingPageFactoryService
                ) {
        super(loggerService);
    }

    getPage(pageUrl: string, pageType: string): Observable<IMarketingPage> {
        const url = `/pages/?pageUrl=${pageUrl}&pageType=${pageType}`;
        return this.http.get(this.urlService.buildCartUrl(url)).pipe(
            map((response: IMarketingPage) => response),
            catchError((error: any) => throwError(error))
        );
    }

    getPreviewPage(pageUrl: string, millisecondsSinceEpoch: string, pageType: string, pageCountry: string): Observable<IMarketingPage> {
        const url = `/pages/preview/?pageUrl=${pageUrl}&pageType=${pageType}&millisecondsSinceEpoch=${millisecondsSinceEpoch}&country=${pageCountry}`;
        return this.http.get(this.urlService.buildCartUrl(url)).pipe(
            map((response: IMarketingPage) => response),
            catchError((error: any) => throwError(error))
        );
    }

    getPlaceholderComponent(componentName: string): Type<any> | null {
        switch (componentName) {
            case Constants.MARKETING_PAGE_PLACEHOLDER_NAV_CATEGORY: {
                return this.marketingPageFactoryService.navCategoryComponent;
            }
            case Constants.MARKETING_PAGE_PLACEHOLDER_FEATURED_PRODUCTS_ROW: {
                return this.marketingPageFactoryService.featuredProductsRowComponent;
            }
            case Constants.MARKETING_PAGE_PLACEHOLDER_FEATURED_PRODUCTS_ROW_GUIDED: {
                return this.marketingPageFactoryService.featuredProductsRowGuidedComponent;
            }
            case Constants.MARKETING_PAGE_PLACEHOLDER_LANDING_AD_HERO: {
                return this.marketingPageFactoryService.landingAdHeroComponent;
            }
            case Constants.MARKETING_PAGE_PLACEHOLDER_LANDING_AD_HERO_GUIDED: {
                return this.marketingPageFactoryService.landingAdGuidedComponent;
            }
            case Constants.MARKETING_PAGE_PLACEHOLDER_LANDING_AD_SIDE_BY_SIDE: {
                return this.marketingPageFactoryService.landingAdSideBySideComponent;
            }
            default:
                return null;
        }
    }

}
